import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, flatMap, switchMap } from 'rxjs/operators';
import * as fromShared from '../../../shared';
import * as TraceLoggingOverrideActions from './trace-logging-override.actions';
import { InternalAdminService } from '../../internal-admin.service';

@Injectable()
export class TraceLoggingOverrideEffects {
    constructor(
        private actions$: Actions,
        private service: InternalAdminService
    ) {}

    get$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(TraceLoggingOverrideActions.getTraceLoggingOverride),
            switchMap(() =>
                this.service.getTraceLoggingOverrides().pipe(
                    flatMap(resp => [
                        TraceLoggingOverrideActions.loadTraceLoggingOverrides({
                            overrides: JSON.parse(resp || '[]')
                        })
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    post$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(TraceLoggingOverrideActions.postTraceLoggingOverride),
            switchMap(action =>
                this.service.postTraceLoggingOverride(action).pipe(
                    flatMap(() => [TraceLoggingOverrideActions.getTraceLoggingOverride()]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    put$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(TraceLoggingOverrideActions.putTraceLoggingOverride),
            switchMap(action =>
                this.service.putTraceLoggingOverride(action).pipe(
                    flatMap(() => [TraceLoggingOverrideActions.getTraceLoggingOverride()]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
}
